import { useSyncExternalStore } from 'react'
import { UserPreferencesPort } from '@/domains/user-preference/UserPreferencePort'
import { Language, AVAILABLE_LANGUAGES } from '@/domains/Language'
import { StoreDto, TeamDto } from '@/infra/api/generated/model'

type UserPreferencesState = {
  store: StoreDto | undefined
  team: TeamDto | undefined
  language: Language | undefined
  isConfigured: boolean
}

export const useUserPreferences = (port: UserPreferencesPort): UserPreferencesState => {
  // Le snapshot combine les IDs sous forme de chaîne de caractères unique
  useSyncExternalStore(
    (cb) => port.subscribe(cb),
    () => `${port.getStore()?.id}-${port.getTeam()?.id}-${port.getLanguageId()}`,
    () => `${port.getStore()?.id}-${port.getTeam()?.id}-${port.getLanguageId()}`
  )

  const store = port.getStore()
  const team = port.getTeam()
  const languageId = port.getLanguageId()

  const language = languageId
    ? AVAILABLE_LANGUAGES.find((lang) => lang.id === languageId)
    : undefined

  return {
    store,
    team,
    language,
    isConfigured: Boolean(store && team && language),
  }
}
